export default "__VITE_ASSET__OJLv6ZVj__"